import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import getSizes from "@/lib/utils/sizes";
import { BlokData } from "@/srpc/routes/story/story.router";
import {
  CollectionCardStoryblok,
  MediaStoryblok,
  TaggedImageStoryblok,
} from "@/types/blok-types";
import clsx from "clsx";
import Link from "next/link";
import styles from "./collection-card.module.css";

const CollectionCard = ({
  imageBlok,
  sizes,
  heading,
  regularTag,
  boldTag,
  preview,
  fullslug,
}: {
  imageBlok: MediaStoryblok | TaggedImageStoryblok;
  sizes: string;
  heading?: string;
  regularTag?: string;
  boldTag?: string;
  slug: string;
  fullslug: string;
  preview: boolean;
}) => {
  const BoldTag = () =>
    !boldTag ? null : <strong className={styles.bold__tag}>{boldTag}</strong>;
  const RegularTag = () =>
    !regularTag ? null : (
      <span className={styles.regular__tag}>{regularTag}</span>
    );
  const Tags = () =>
    !boldTag && !regularTag ? null : (
      <div className={styles.tags}>
        <BoldTag />
        <RegularTag />
      </div>
    );
  const Heading = () =>
    !heading ? null : <p className={styles.heading}>{heading}</p>;
  const CardImage = () =>
    !imageBlok ? null : (
      <div className={styles.image}>
        <StoryblokComponent blok={imageBlok} sizes={sizes} preview={preview} />
      </div>
    );

  return (
    <Link className={clsx(styles.root, "collection-card")} href={`${fullslug}`}>
      <CardImage />
      <Tags />
      <Heading />
    </Link>
  );
};

const Card = ({
  collection,
  preview,
}: {
  collection: BlokData["collection"];
  preview: boolean;
}) =>
  !collection ? null : (
    <CollectionCard
      preview={preview}
      imageBlok={
        collection.content.listingImage?.[0] as
          | MediaStoryblok
          | TaggedImageStoryblok
      }
      sizes={getSizes(100, 33)}
      heading={collection.content.Title}
      regularTag={collection.content.regularTag}
      boldTag={collection.content.boldTag}
      key={collection?.uuid}
      slug={collection.slug}
      fullslug={collection.full_slug}
    />
  );

export const CollectionCardBlok = ({
  blok,
  data,
  preview,
}: {
  blok: CollectionCardStoryblok;
  data: BlokData["collection"];
  preview: boolean;
}) => {
  return <Card collection={data} preview={preview} />;
};

export default CollectionCard;
